/**
 * Cross-fade slideshow for cowp/partner-hero in gallery mode.
 *
 * Progressive enhancement only: the first slide is already marked active in
 * the markup, so the hero is correct without this script. The fade itself is
 * a CSS opacity transition; this only moves the .is-active class along.
 * Pauses while the hero is off-screen or the tab is hidden, and does nothing
 * under prefers-reduced-motion.
 */
var ROOT_SELECTOR = '[data-cowp-hero-fade]';
var SLIDE_SELECTOR = '.cowp-partner-hero__media .cowp-partner-hero__slide';
var ACTIVE_CLASS = 'is-active';
function readMs(value, fallback) {
    var parsed = Number.parseInt(value !== null && value !== void 0 ? value : '', 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}
function initHero(root) {
    var slides = Array.from(root.querySelectorAll(SLIDE_SELECTOR));
    if (slides.length < 2) {
        return;
    }
    var fade = readMs(root.dataset.fade, 1200);
    // The delay is the time a slide stays fully visible, so the interval also
    // has to cover the fade itself.
    var interval = readMs(root.dataset.delay, 6000) + fade;
    var current = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains(ACTIVE_CLASS); }));
    var timer = null;
    var inView = true;
    var advance = function () {
        var next = (current + 1) % slides.length;
        slides[next].classList.add(ACTIVE_CLASS);
        slides[current].classList.remove(ACTIVE_CLASS);
        current = next;
    };
    var start = function () {
        if (timer !== null || !inView || document.hidden) {
            return;
        }
        timer = window.setInterval(advance, interval);
    };
    var stop = function () {
        if (timer === null) {
            return;
        }
        window.clearInterval(timer);
        timer = null;
    };
    // Lazy slides would otherwise only start loading when they first fade in.
    slides.forEach(function (slide) {
        slide.querySelectorAll('img').forEach(function (img) {
            img.loading = 'eager';
        });
    });
    if (typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver(function (entries) {
            inView = entries.some(function (entry) { return entry.isIntersecting; });
            if (inView) {
                start();
            }
            else {
                stop();
            }
        }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
            stop();
        }
        else {
            start();
        }
    });
    start();
}
export function initPartnerHeroFades() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }
    document.querySelectorAll(ROOT_SELECTOR).forEach(initHero);
}
